import AnalyticsVM from './analytics-vm';
import StudentEngagment from './student-engagement';
import Vue from 'vue';
import 'libs/vue-extensions';

export default {
  init : function() {
    console.log('Kadenze.CourseAnalytics initialization function called');
    var analyticsData = JSON.parse($('#course-analytics-json').val());

    if (document.getElementById('student-view')) {
      const studentEngagementVM = new Vue(StudentEngagment);
      studentEngagementVM.$mount(document.getElementById('student-view'));
      studentEngagementVM.bindData(analyticsData);  
    }
    
    ko.applyBindingsWithValidation(new AnalyticsVM(analyticsData), document.getElementById('js-course-analytics-view'), Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);
  }
};

